/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new Swiper(".sp-swiper1", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  $(".selectl span").click(function () {
    $(this).addClass("on").siblings().removeClass("on");
    let index = $(this).index();
    const imgWrap = $(this).closest(".content").siblings(".img-wrap");
    imgWrap.find(".p-img").hide().eq(index).show();
  });
  let prods = window.product
  function getCur(){
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-size div.active').attr('data-val')
    let num = $('#sp-num div.active').attr('data-val')
    
    return prods.filter(item=> item.option1 == color && item.option2 == size && item.option3 == num)[0]
  }
  function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    $(".product-part .price-group .sp-row span").html(off_font);
  }
  let swiper = new Swiper(".swiper-product", {
    // speed: 1,
    allowTouchMove: false,
  });


  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    let colorOptions = $("#sp-color .sp-option.active").index();
    let sizeOptions = $("#sp-size .sp-option.active").index();
    let numOptions = $("#sp-num .sp-option.active").index();
    let _index = colorOptions + sizeOptions*2 + numOptions*4;
    swiper.slideTo(_index);
    changePrice()
  });

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
      changePrice()
    }
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  $('.sp-btn-style').click(function(){
    const id = $(this).prev().find(".on").attr("data-id")
    let num = 1
    window.location.href = '/cart/' + id + ':' + num
  })
   $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  $(".product-part .cart-btn").click(function () {
    $(".sp-cart .sp-num").removeClass("sp-gray")
    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
    
    var img = $(".product-part .swiper-product .swiper-slide-active img");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + 10 + $('.time-part').height(),
        left: finish[0].offsetLeft + 30 + finish.width() / 3,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      800,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });
  // let spprev = document.querySelector(".sp-swiper-btn-prev");
  // let spnext = document.querySelector(".sp-swiper-btn-next");
  // spnext.addEventListener("click", function () {
  //   let items = document.querySelectorAll(".sp-swiper-item");
  //   document.querySelector(".sp-swiper-box").appendChild(items[0]);
  // });
  // spprev.addEventListener("click", function () {
  //   let items = document.querySelectorAll(".sp-swiper-item");
  //   document.querySelector(".sp-swiper-box").prepend(items[items.length - 1]);
  // });
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();



  // 获取images元素
  const images = document.querySelectorAll(".slider-images img");
  const water = document.querySelectorAll(".sp-part1 .sp-bg");
  

  // 设置初始索引
  let imageIndex = 0;

  // 获取前一个image的索引
  function getPrevImageIndex() {
    return (imageIndex - 1 + images.length) % images.length;
  }

  // 获取下一个image的索引
  function getNextImageIndex() {
    return (imageIndex + 1) % images.length;
  }

  // 更新 slider
  function updateSlider() {
    // 获取前一个image的索引
    let prevImageIndex = getPrevImageIndex();
    // 获取下一个image的索引
    let nextImageIndex = getNextImageIndex();

    // 从images数组中删除所有的active, previous, next, inactive类
    images.forEach((image) => {
      image.classList.remove("active", "previous", "next", "inactive");
    });
    water.forEach((water) => {
      water.classList.remove("active", "inactive");
    });
    water[imageIndex].classList.add("active");

    // 当前image元素增加active类
    images[imageIndex].classList.add("active");

    // 对前一个image元素增加previous类
    images[prevImageIndex].classList.add("previous");

    // 对后一个image元素增加next类
    images[nextImageIndex].classList.add("next");

    // 对于其他的image元素, 增加inactive类
    images.forEach((image, index) => {
      if (
        index !== imageIndex &&
        index !== prevImageIndex &&
        index !== nextImageIndex
      ) {
        image.classList.add("inactive");
      }
    });
    water.forEach((water, index) => {
      if (
        index !== imageIndex
      ) {
        water.classList.add("inactive");
      }
    });
    
    
    // 更新image索引
    imageIndex = nextImageIndex;
    // setTimeout(function () {
    //   water.style.opacity = 0;
    // }, 3000);
    

    $(".sp-group .sp-p")
      .eq(imageIndex - 1)
      .addClass("sp-active")
      .siblings()
      .removeClass("sp-active");
  }

  // 立即更新
  updateSlider();
  // 定时更新
  setInterval(updateSlider, 3000);



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
// 展示尺码弹窗
  $('.sp-btn-pop').click(function () {
    $('.sp-mask').css('display', 'flex')
    // $(".sp-pop").show();
  })
  // 关闭弹窗按钮

  $('.sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    // $(".sp-pop").hide();
  })
